<template>
	<div class="c-flex-content">
		<div class="c-flex-content__slice-container" v-for="slice in this.content">
			<div :class="'c-flex-content__slice c-flex-content__slice--' + slice.type" v-if="slice.type === 'text'">
				<div v-html="slice.value"></div>
			</div>
			<div :class="'c-flex-content__slice c-flex-content__slice--' + slice.type" v-if="slice.type === 'html_snippet'">
				<div :class="slice.isFacebookVideo ? 'c-flex-content__html-snippet is-facebook' : 'c-flex-content__html-snippet'" v-append="slice.code" />
			</div>
			<div :class="'c-flex-content__slice c-flex-content__slice--' + slice.type" v-if="slice.type === 'images'">
				<figure v-for="image in slice.images" :class="'c-flex-content__image-wrapper c-flex-content__image-wrapper--' + image.imageSize">
					<img :src="image.imageUrl" :alt="image.imageAltText" :class="'c-flex-content__image c-flex-content__image--' + image.imageSize">
					<figcaption v-html="image.caption" v-if="image.caption"></figcaption>
				</figure>
			</div>
			<div :class="'c-flex-content__slice c-flex-content__slice--' + slice.type" v-if="slice.type === 'oembed'">
				<c-oembed :oembedData="slice.oembedData" />
			</div>
			<div :class="'c-flex-content__slice c-flex-content__slice--' + slice.type" v-if="slice.type === 'teaser_block'">
				<c-teaser-block :teaserData="slice.teaserData" />
			</div>
		</div>
	</div>
</template>

<script>
import COembed from '@/components/OEmbed';
import CTeaserBlock from '@/components/TeaserBlock';

export default {
	name: 'flex-content',
	props: ['content'],
	data: () => ({
		injectedScripts: {}
	}),
	components: {
		COembed,
		CTeaserBlock
	},
	updated () {
		/**
		 * Execute script tags by recreating them and appending them to the body
		 * This is not very safe :-(
		 * tested with:
		 * - Twitter Widget (Works)
		 * - Instagram Widget (Broken - It would require a reinitialisation)
		 */
		const scriptTags = this.$el.getElementsByTagName('script')
		for (var i = 0; i < scriptTags.length; i++) {
			const currentScriptTag = scriptTags[i]
			if (!this.injectedScripts[currentScriptTag.src]) {
				const script   = document.createElement("script")
				script.type = 'text/javascript'
				script.src = scriptTags[i].src
				document.body.appendChild(script)
				this.injectedScripts[script.src] = script
			}
		}
	},
	destroyed () {
		Object.keys(this.injectedScripts).forEach(s => this.injectedScripts[s].remove())
	}
}
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.c-flex-content {
		&__slice {
			margin: 2rem 0;

			&--images {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
			}
		}
		&__image {
			width: 100%;
			height: auto;
		}
		&__image-wrapper {
			margin: 0;
			margin-bottom: 1rem;

			&--half {
				width: 100%;

				@include mq($from: medium) {
					width: 49%;
				}
			}
			&--full {
				width: 100%;
			}
			figcaption {
				font-size: .8rem;
				color: $colorGray;

				p {
					margin: 0;
				}
			}
		}
		&__html-snippet {
			&.is-facebook {
				position: relative;
				padding-bottom: 56.25%;
				height: 0;
				overflow: hidden;
				max-width: 100%;

				iframe, object, embed {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// FlexContent.vue?359079ca